export class UserWallet {
  walletId!: number;
  name!: string;
  isMain!: boolean;
  balance!: number;

  constructor(props: any) {
    this.walletId = props.walletId;
    this.name = props.name;
    this.isMain = props.isMain;
    this.balance = props.balance;
  }

}
